import React from "react";
//#region types
import { AuthEnums } from "models/enums";
import { ShareRegisterToApproveMoreActionsProps } from "models/propTypes/shareRegisterPropTypes";
//#endregion
//#region components
import { MoreActions } from "components/common";
import useShareRegisterSnoozeAction from "./actions/useSnoozeAction";
//#endregion
import { CompanyService } from "services";

const ShareRegisterToApproveMoreActions: React.FC<ShareRegisterToApproveMoreActionsProps> = (props) => {
  const { id, onActionSuccess, disableSuccessMessages } = props;

  const snoozeAction = useShareRegisterSnoozeAction(id, onActionSuccess);

  const getMenuItems = () => {
    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);
    if (!isAuditor) {
      return [snoozeAction];
    } else return [];
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default ShareRegisterToApproveMoreActions;
